// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { ModalEl } from 'common/components/modal';
export const faqModal = (isOpen, faqHandler, overagePricePerEventString) => {
  return <ModalEl attrs={{
    open: isOpen,
    closeable: true
  }} on={{
    change: faqHandler
  }} sel='.faq-modal' data-sentry-element="ModalEl" data-sentry-component="faqModal" data-sentry-source-file="faq-modal.tsx">
      <div sel='.faq-content'>
        <div sel='.faq-title'>How to choose your event volume</div>
        <div sel='.faq-item'>
          1. Multiply the number of your monthly active users by the estimated number of events (interactions) a typical
          active user performs in your product every month.
        </div>
        <div sel='.faq-item'>
          {overagePricePerEventString ? <>
              2. You'll be charged at a volume discount price for the number of events selected in your plan. Each
              additional event will cost <span sel='.bold'>{overagePricePerEventString}</span>.
            </> : <>2. Allow your company room to grow and save money in the process. Volume discounts are baked in.</>}
        </div>
        <div sel='.faq-item'>
          3. If you're already on a{" "}
          <a sel='.faq-link' attrs={{
          href: "/register/"
        }}>
            Starter plan
          </a>
          , you can track your monthly data usage to accurately estimate your event volume.
        </div>
        <div sel='.divider' />
        <div sel='.support-link'>
          Need help? Contact{" "}
          <a sel='.faq-link' attrs={{
          href: "/get-support",
          target: "_blank"
        }}>
            support
          </a>
        </div>
      </div>
    </ModalEl>;
};